import DotNetObject = DotNet.DotNetObject;
import { AxPart } from '@crimsontide/core/client/interfaces';

export const AxPartService = (() => {
  let dotNetObj: DotNetObject;
  let cachedAxParts: AxPart[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getAxParts = async (useCache: boolean = true): Promise<AxPart[]> => {
    if (useCache && cachedAxParts != null)
      return cachedAxParts;

    if (dotNetObj) {
      cachedAxParts = await dotNetObj.invokeMethodAsync<AxPart[]>('GetAsync');
      return cachedAxParts;
    } else {
      throw 'AxPart DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getAxParts,
  };
})();
